import DisplayFieldWithUTCOffset, {
    type DisplayFieldWithUTCOffsetProps,
} from '../../../components/fields/DisplayFieldWithUTCOffset';
import { StyledDisplay } from './shared';

const DisplayFieldFormWithUTCOffset = (props: DisplayFieldWithUTCOffsetProps) => (
    <StyledDisplay>
        <DisplayFieldWithUTCOffset {...props} />
    </StyledDisplay>
);

export default DisplayFieldFormWithUTCOffset;
